const API = `${window.location.origin}/api`;

let initialized = false;
const recentReports = new Map();
let sentTimestamps = [];
const DEDUPE_WINDOW_MS = 30000;
const MAX_PER_MINUTE = 10;

function shouldReport(key) {
  const now = Date.now();
  const last = recentReports.get(key);
  if (last && now - last < DEDUPE_WINDOW_MS) return false;
  sentTimestamps = sentTimestamps.filter((t) => now - t < 60000);
  if (sentTimestamps.length >= MAX_PER_MINUTE) return false;
  recentReports.set(key, now);
  sentTimestamps.push(now);
  if (recentReports.size > 100) {
    const oldest = recentReports.keys().next().value;
    recentReports.delete(oldest);
  }
  return true;
}

function report(payload) {
  try {
    if (!payload.message || payload.message.includes('errors/frontend')) return;
    const key = `${payload.severity}:${payload.message}`.slice(0, 300);
    if (!shouldReport(key)) return;
    const headers = { 'Content-Type': 'application/json' };
    const token = localStorage.getItem('token');
    if (token) headers.Authorization = `Bearer ${token}`;
    fetch(`${API}/errors/frontend`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        ...payload,
        url: window.location.pathname,
        user_agent: navigator.userAgent,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // reporter must never throw
  }
}

function stringifyArg(a) {
  if (a instanceof Error) return a.message;
  if (typeof a === 'object' && a !== null) {
    try {
      return JSON.stringify(a).slice(0, 300);
    } catch (e) {
      return '[object]';
    }
  }
  return String(a);
}

function captureConsole(severity, args) {
  try {
    const message = args.map(stringifyArg).join(' ').slice(0, 1000);
    if (!message || message.startsWith('Warning:')) return;
    const err = args.find((a) => a instanceof Error);
    report({ severity, message, source: `console.${severity}`, stack: err?.stack?.slice(0, 3000) || null });
  } catch (e) {
    // never throw
  }
}

export function initErrorReporter() {
  if (initialized) return;
  initialized = true;

  window.addEventListener('error', (event) => {
    report({
      severity: 'error',
      message: (event.message || 'Unknown error').slice(0, 1000),
      source: event.filename || 'window.onerror',
      stack: event.error?.stack?.slice(0, 3000) || null,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    report({
      severity: 'error',
      message: (reason?.message || String(reason)).slice(0, 1000),
      source: 'unhandledrejection',
      stack: reason?.stack?.slice(0, 3000) || null,
    });
  });

  const origError = console.error;
  console.error = (...args) => {
    origError.apply(console, args);
    captureConsole('error', args);
  };

  const origWarn = console.warn;
  console.warn = (...args) => {
    origWarn.apply(console, args);
    captureConsole('warn', args);
  };
}
